import api from 'api';
import { NextPageContext } from 'next';

type Params = Pick<NextPageContext, 'req' | 'reduxStore'>;

const getSupervisorData = async ({ reduxStore, req }: Params) => {
  try {
    const { user } = reduxStore.getState();
    if (!user) return null;

    const headers = req?.headers?.cookie ? { Cookie: req.headers.cookie } : {};

    const response = await api.get(`/admin/supervisors?userId=${user.id}`, {
      ...(headers.Cookie ? { headers } : {})
    });
    if (response.data.success) return response.data.supervisors[0];
    else return null;
  } catch (err) {
    return null;
  }
};

export default getSupervisorData;
